/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';

import { navigation, reportLibrary, myReports } from 'modules/reports/controller';

export default (router) => {
	router(`/reports/my-reports`, navigation, myReports, makeLayout, render);
	router(`/reports/report-library`, navigation, reportLibrary, makeLayout, render);
};
